import { Bom3PosColumn } from "./Bom3PosColumn";

// сложности возникли из-за колонок цветомоделей. они меняются для разных экземпляров бомов.
// см коммент в https://jira.axetechgroup.com/browse/LPLM-5687
// поэтому нет смысла сохранять порядок для отдельных колонок цветомоделей.
// вместо этого считается что все цветомодели объединяются в одну группу, которая обозначается квази-ключом
// порядок определяется для группы. а внутри группы положение менять нельзя.

export const colorModelQuasiKey = "@ColorModel";

// замена реальных ключей колонок цветомоделей на квази-ключ, который будет представлять любые колонки цветомодели
export const convertRealOrderToQuasi = (
  realOrder: string[],
  columns: Bom3PosColumn[],
): string[] => {
  const dict: Record<string, Bom3PosColumn> = {};
  columns.forEach((col) => {
    dict[col.key] = col;
  });
  const dstOrder: string[] = [];
  let colorModelUsed = false;
  realOrder.forEach((key) => {
    const col = dict[key];
    if (col?.isColorModel) {
      if (!colorModelUsed) {
        dstOrder.push(colorModelQuasiKey);
        colorModelUsed = true;
      }
    } else {
      dstOrder.push(key);
    }
  });
  return dstOrder;
};

export const convertQuasiOrderToReal = (
  quasiOrder: string[],
  columns: Bom3PosColumn[],
): string[] => {
  const cmPos = quasiOrder.indexOf(colorModelQuasiKey);
  if (cmPos < 0) return quasiOrder;
  const leftPart = quasiOrder.slice(0, cmPos);
  const rightPart = quasiOrder.slice(cmPos + 1);
  const midPart = columns
    .filter(({ isColorModel }) => isColorModel)
    .map(({ key }) => String(key));
  return [...leftPart, ...midPart, ...rightPart];
};

export const correctRealOrder = (
  order: string[],
  columns: Bom3PosColumn[],
): string[] => {
  const colorModelKeys = columns
    .filter(({ isColorModel }) => isColorModel)
    .map(({ key }) => String(key));
  if (colorModelKeys.length < 2) return order;
  const [cmFirst, ...cmRest] = colorModelKeys;
  const excluded = new Set(cmRest);
  const newOrder = order.filter((key) => !excluded.has(key));
  const pos = newOrder.indexOf(cmFirst!) + 1;
  return [...newOrder.slice(0, pos), ...cmRest, ...newOrder.slice(pos)];
};
